import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  fee: {
    display: "flex",
    alignItems: "stretch",
    height: 56,
  },
  feeName: {
    maxWidth: "28vw",
    maxHeight: 42,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  feeContent: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: theme.spacing(8),
  },
}));
